/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ExtractFileTreeFileParser = /* #__PURE__ */ parsers.object([['name', codecString]]);
export class ExtractFileTreeFile extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ExtractFileTreeFileParser.decode(input).map(res => new ExtractFileTreeFile(res));
    }
    static unsafeDecode(input) {
        return ExtractFileTreeFile.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ExtractFileTreeFileParser.encode(data);
    }
    static schema() {
        return ExtractFileTreeFileParser.schema();
    }
}
